<template>
    <div>
       硬件模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
